var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2 12 9-9 9 9","stroke":"currentColor","strokeWidth":"3"}));
}

Arrow.defaultProps = {"fill":"none","viewBox":"0 0 22 14"};

module.exports = Arrow;

Arrow.default = Arrow;
